import { apiRequest } from '@/core';
import { type DeleteIncidentPayload } from '@/slices/events/types';

export const deleteIncidentRequest = async ({
  incidentId,
}: DeleteIncidentPayload) =>
  apiRequest<void>({
    endpoint: `api/incidents/${incidentId}`,
    method: 'DELETE',
  });
